import React from "react"
import { FontAwesome5, Ionicons, MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons"
import moment from "moment"
import momentTZ from "moment-timezone"
import { baseColors } from "@Constants/baseStyles"
import SvgAviron from "@Components/CustomIcon/SvgAviron"
import SvgYoga from "@Components/CustomIcon/SvgYoga"
import SvgGainage from "@Components/CustomIcon/SvgGainage"
import SvgEquitation from "@Components/CustomIcon/SvgEquitation"
import SvgEscalade from "@Components/CustomIcon/SvgEscalade"
import SvgCourse from "@Components/CustomIcon/SvgCourse"
import SvgCalendarIcon from "@Components/CustomIcon/SvgCalendarIcon"
import SvgMusculationIcon from "@Components/CustomIcon/SvgMusculationIcon"
import SvgPillsIcon from "@Components/CustomIcon/SvgPillsIcon"
import { Alert } from "react-native"
import { uniqBy } from "lodash"
import Constants from "expo-constants"

moment.locale("fr")

const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{"':;?/>,<.]).{8,}$/

export const ClientDateFormat = (date) => moment(date).format("DD/MM/YYYY")

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}

export const enumerateDaysBetweenDates = function (startDate, endDate) {
    var dates = []

    var currDate = moment(startDate).subtract(1, "day").startOf("day")
    var lastDate = moment(endDate).startOf("day")

    while (currDate.add(1, "days").diff(lastDate) <= 0) {
        dates.push(currDate.clone().toDate())
    }

    return dates
}

export const getDay = (date) => {
    return moment(date).format("D")
}

export const getMonthAndYear = (date) => moment(date).format("MMMM YYYY")

export const getDayFirstLetter = (date) => {
    return moment(date).format("dd").substr(0, 1).toUpperCase()
}
export const timeUnitConverter = (time) => {
    let value = ""
    switch (time) {
        case "week":
            value = "semaine(s)"
            break
        default:
            value = "jour(s)"
            break
    }
    return value
}
export const changeSelectedValue = (value, setValue) => setValue((prev) => (prev === value ? null : value))

export const randomColor = (colors) => colors[Math.floor(Math.random() * colors.length)]

export const isValidEmail = (email) => {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
}
export const isValidPassword = (pwd) => pwd.length > 7
export const isNotBlank = (str) => str.trim().length > 0
export const areEqual = (a, b) => a.length == b.length && a == b
export const dbDateFormat = "YYYY-MM-DD"
export const dbDateTimeFormat = "YYYY-MM-DD HH:mm"
export const dateTimeFormat = "DD-MM-YYYY HH:mm"
export const dateTimeFR = "DD-MM-YYYY à HH:mm"
export const localDateFormat = "DD/MM/YYYY"
export const validDate = (date) => /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/.test(date)
export const getYear = (date) => {
    var years = moment(new Date()).diff(moment(date, dbDateFormat), "years", false)
    return years
}
//yyyy-MM-dd date
export const getSecondFromNow = (date) => {
    const now = moment(new Date())
    const futur = moment(date, dbDateTimeFormat)
    if (now.isAfter(futur)) {
        return -1 // 10second
    } else {
        return Math.round(moment.duration(futur.diff(now)).asSeconds())
    }
}
export const isValidTime = (string) => /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(string)
export const isNumber = (string) => /^\d+$/.test(string)
export function truncateString(str, num) {
    if (str.length > num) {
        return str.slice(0, num) + "..."
    } else {
        return str
    }
}
export const getSportIcon = (sportName, color = baseColors.white, size = 38) => {
    switch (sportName.toLowerCase()) {
        case "natation":
            return <FontAwesome5 name={"swimmer"} size={size} color={color} />
        case "aviron":
        case "musculation":
            return <SvgAviron size={size} color={color} />
        case "yoga":
            return <SvgYoga size={size} color={color} />
        case "gainage":
            return <SvgGainage color={color} />
        case "handball":
            return <MaterialIcons name={"sports-handball"} size={size} color={color} />
        case "vélo":
            return <Ionicons name={"bicycle"} size={size} color={color} />
        case "basketball":
            return <FontAwesome5 name={"basketball-ball"} size={size} color={color} />
        case "equitation":
            return <SvgEquitation color={color} />
        case "escalade":
            return <SvgEscalade size={size} color={color} />
        case "football":
            return <Ionicons name={"football"} size={size} color={color} />
        case "course à pied":
            return <SvgCourse size={size} color={color} />
        case "marche":
            return <FontAwesome5 name={"walking"} size={size} color={color} />
        case "rugby":
            return <MaterialCommunityIcons name={"rugby"} size={size} color={color} />
        case "golf":
            return <MaterialIcons name={"sports-golf"} size={size} color={color} />
        case "tennis":
            return <MaterialIcons name={"sports-tennis"} size={size} color={color} />
        default:
            return <MaterialIcons name={"sports"} size={size} color={color} />
    }
}

export const getReminderIcon = (reminderType) => {
    switch (reminderType) {
        case "Prise des constantes":
            return <SvgPillsIcon height={27} width={27} />
        case "Prise de médicaments":
            return <SvgPillsIcon height={27} width={27} />
        case "Rendez-vous":
            return <SvgCalendarIcon height={27} width={27} />
        case "Activité sportive":
            return <SvgMusculationIcon height={27} width={27} />
        default:
            return <SvgMusculationIcon height={27} width={27} />
    }
}

const fullName = (firstName, lastName) => {
    if (!firstName || !lastName) {
        return ""
    }
    if (firstName && !lastName) {
        return firstName
    }
    if (!firstName && lastName) {
        return lastName
    }
    if (firstName && lastName) {
        return `${lastName} ${firstName}`
    }

    return ""
}

const specialCharToUnderscore = (str) => str.replace(/[^a-zA-Z0-9]/g, "_")

const frenchDate = (date) => moment(new Date(date)).format("LLL")
export function generateUUID() {
    // Public Domain/MIT
    var d = new Date().getTime() //Timestamp
    var d2 = (typeof performance !== "undefined" && performance.now && performance.now() * 1000) || 0 //Time in microseconds since page-load or 0 if unsupported
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 //random number between 0 and 16
        if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0
            d = Math.floor(d / 16)
        } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0
            d2 = Math.floor(d2 / 16)
        }
        return (c === "x" ? r : (r & 0x3) | 0x8).toString(16)
    })
}

export const groupBy = (original, nbr) => {
    let grouped = []

    grouped = original.reduce(function (accumulator, currentValue, currentIndex, array) {
        if (currentIndex % nbr === 0) accumulator.push(array.slice(currentIndex, currentIndex + nbr))
        return accumulator
    }, [])
    return grouped
}
export { fullName, specialCharToUnderscore, frenchDate }

export const confirmAction = (title, message, cancelText, confirmText, confirmCallback, canceCallback) => {
    Alert.alert(title, message, [
        {
            text: cancelText,
            onPress: () => {
                canceCallback?.()
            }
        },
        {
            text: confirmText,
            onPress: () => {
                confirmCallback?.()
            }
        }
    ])
}
export const freeslotDateFormat = "YYYY-MM-DDThh:mm:ss"

export function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min)
}

const isStrongPassword = (password) => {
    // const regex = new RegExp("^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{"':;?/>,<.]).{8,}")
    return passwordRegex.test(password)
}

const isValideName = (name) => {
    const regex = new RegExp("^(?=.*[A-Za-z0-9]).{3,50}$")
    return regex.test(name)
}

const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0
}

const dateTimeWithoutTimeZone = (date) => moment(date).utcOffset(date).set("minute", 0).format(dbDateTimeFormat)

const POST_TYPE = {
    text: "TYPE_TEXT",
    image: "TYPE_IMAGE",
    videos: "TYPE_VIDEO"
}

const WORKSHOP_TYPE = {
    inSite: "PRESENTIEL",
    visio: "VISIO"
}

const KNOWLEDGE_TYPE = {
    faire: "SAVOIR_FAIRE"
}

function convertToTimeZoneDate(date) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const addTimeZoneToDate = momentTZ.tz(date, timezone).format()
    return addTimeZoneToDate
}

function convertToDateTimeSecond(date) {
    const datime = moment(date).tz("Europe/Paris").format("YYYY-MM-DD HH:mm:ss")
    return datime
}

function removeTimeZone(date) {
    const res = date?.split("T")?.[0]
    return res
}

function removeDateTimeZonePlus(dateTime) {
    const res = dateTime?.split("+")?.[0]
    return res
}

function EqualDates(d1, d2) {
    let date1 = new Date(d1).getTime()
    let date2 = new Date(d2).getTime()

    if (date1 < date2) {
        console.log(`${d1} is less than ${d2}`)
        return false
    } else if (date1 > date2) {
        console.log(`${d1} is greater than ${d2}`)
        return false
    } else {
        console.log(`Both dates are equal`)
        return true
    }
}

function GreaterThanNowDate(date) {
    let date1 = new Date(date).getTime()
    let dateRdvMinutes = new Date(date)
    let dateMinus5Minutes = dateRdvMinutes?.setMinutes(dateRdvMinutes?.getMinutes() - 5)
    let now = new Date().getTime()
    if (now >= date1 || now >= dateMinus5Minutes) {
        return true
    }
    return false
}

function LowerThanNowDate(date) {
    let date1 = new Date(date).getTime()
    let now = new Date().getTime()
    if (now < date1) {
        console.log(`${date1} is lower than ${now}`)
        return true
    }
    return false
}

function isWithin48Hours(dateValue, startDate) {
    const now = new Date()
    const startDateEvent = new Date(startDate)
    const datePlus48Hours = new Date(dateValue)
    datePlus48Hours.setHours(datePlus48Hours.getHours() + 48)
    return (
        (now.getDate() === startDateEvent.getDate() && now.getMonth() === startDateEvent.getMonth()) ||
        (startDateEvent < now && now <= datePlus48Hours)
    )
}

function TransformToLowerCase(value) {
    const lowerValue = value?.toLowerCase()
    return lowerValue ?? ""
}

const UniqByKeyValues = ({ items, key }) => {
    const values = uniqBy(items, key || "id")
    return values ?? []
}

function UseParisDateTimeZone(value, withoutFormat = undefined) {
    const dateTime = moment(value).tz("Europe/Paris").format("HH:mm")
    if (withoutFormat) {
        return moment(value).tz("Europe/Paris")
    }
    return dateTime
}

function differenceBetweenToDateTime(date1, date2) {
    // Parse the datetime strings
    const moment1 = moment(date1)
    const moment2 = moment(date2)

    // Calculate the difference in minutes
    const differenceInMinutes = moment2.diff(moment1, "minutes")

    return differenceInMinutes
}

function isCptsInstance() {
    const { platform } = Constants.expoConfig.extra
    return platform === "cpts"
}

export {
    isWithin48Hours,
    isCptsInstance,
    differenceBetweenToDateTime,
    UseParisDateTimeZone,
    UniqByKeyValues,
    TransformToLowerCase,
    convertToDateTimeSecond,
    LowerThanNowDate,
    GreaterThanNowDate,
    EqualDates,
    removeDateTimeZonePlus,
    removeTimeZone,
    convertToTimeZoneDate,
    KNOWLEDGE_TYPE,
    POST_TYPE,
    WORKSHOP_TYPE,
    isStrongPassword,
    isValideName,
    isEmptyObject,
    dateTimeWithoutTimeZone
}
